import { render } from "./PlusIcon.vue?vue&type=template&id=1f8db0ba&scoped=true"
import script from "./PlusIcon.vue?vue&type=script&lang=js"
export * from "./PlusIcon.vue?vue&type=script&lang=js"

import "./PlusIcon.vue?vue&type=style&index=0&id=1f8db0ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8db0ba"]])

export default __exports__